import React from 'react';
import { BrowserRouter as Router, Route, Switch} from 'react-router-dom';

import Esquecisenha from '../components/features/Esquecisenha';
import Login from '../components/Login';

export default function Rotas() {
  return(
      <Router>
        <Switch>
            <Route exact path="/" component={Login} />
            <Route exact path="/esquecisenha" component={Esquecisenha} />
            <Route path='/' component={Login} />
            <Route path='*' component={Login} />
        </Switch>
      </Router>
  );
}
